import TabsRouting from '@components/tabs-routing'
import { TabsContainer } from '@components/tabs-routing/index.styles'
import { Analytics } from '@core/services/mixpanel'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ROUTES } from '@/core/config/routing'

const { account, user, team } = ROUTES.settings.children

const SETTINGS_TABS = [
    { id: 'settings-tab-account', tab: 'account', route: account },
    { id: 'settings-tab-user', tab: 'user', route: user },
    { id: 'settings-tab-team', tab: 'team', route: team },
]

const SettingsRoute = () => {
    Analytics.event('SEM::users_clicks_settings_menu')

    const { pathname } = useLocation()
    const activeTab = SETTINGS_TABS.find(
        ({ route }) => route.path === pathname
    )?.tab

    useEffect(() => {
        if (!activeTab) return

        Analytics.event('SEM::users_clicks_settings_tab', { tab: activeTab })
    }, [activeTab])

    const tabList = SETTINGS_TABS.map(({ id, route }) => ({
        id,
        tabTitle: route.displayName,
        path: route.path,
    }))

    return (
        <>
            <TabsContainer>
                <TabsRouting tabList={tabList} tabsName="settings-tab" />
            </TabsContainer>
            <Outlet />
        </>
    )
}

export default SettingsRoute
